import { createContext, useContext } from 'react';
export var ForcedState = /*#__PURE__*/ function(ForcedState) {
    ForcedState["BUTTONS_HOVER"] = "BUTTONS_HOVER";
    ForcedState["NEXT_BUTTON_HOVER"] = "NEXT_BUTTON_HOVER";
    ForcedState["PREVIOUS_BUTTON_HOVER"] = "PREVIOUS_BUTTON_HOVER";
    ForcedState["SUBMIT_BUTTON_HOVER"] = "SUBMIT_BUTTON_HOVER";
    ForcedState["INPUT_FIELDS_HOVER"] = "INPUT_FIELDS_HOVER";
    ForcedState["INPUT_FIELDS_FOCUS"] = "INPUT_FIELDS_FOCUS";
    ForcedState["INPUT_FIELDS_ERROR"] = "INPUT_FIELDS_ERROR";
    ForcedState["SUCCESS_MESSAGE"] = "SUCCESS_MESSAGE";
    ForcedState["FORM_CLOSED"] = "FORM_CLOSED";
    ForcedState["ERROR_MESSAGE"] = "ERROR_MESSAGE";
    ForcedState["HIDDEN_FIELDS"] = "HIDDEN_FIELDS";
    return ForcedState;
}({});
export const ForcedStateContext = createContext([]);
export const useForcedState = ()=>useContext(ForcedStateContext) || [];

//# sourceMappingURL=forced-state-context.js.map